import { render, staticRenderFns } from "./CardTeacherInfo.vue?vue&type=template&id=63d1ca34&scoped=true&"
import script from "./CardTeacherInfo.vue?vue&type=script&lang=js&"
export * from "./CardTeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardTeacherInfo.vue?vue&type=style&index=0&id=63d1ca34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d1ca34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
